export const getLoginLink = (
  currentLocation: string,
  appConfig: typeof CSS_CONFIG
): string => {
  const country = appConfig?.COUNTRY?.toLowerCase?.() || '';
  const language = appConfig?.LANGUAGE?.toLowerCase?.() || '';
  const locale = `/${country}/${language}`;

  return `${window.location.origin}${locale}/profile/login/?from=${encodeURIComponent(
    currentLocation
  )}`;
};
